import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, FileEdit, LogOut, Ship, ExternalLink, BarChart3 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/admin/content", label: "Site Content", icon: FileEdit },
];

export default function AdminLayout() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-surface" data-testid="admin-layout">
      <div className="flex">
        {/* sidebar */}
        <aside className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r border-border bg-card p-5 lg:flex">
          <Link to="/admin" className="flex items-center gap-2.5">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-white"><Ship className="h-5 w-5" /></span>
            <div><p className="font-heading font-bold leading-none">Domaleo</p><p className="text-xs text-muted-foreground">Admin Panel</p></div>
          </Link>
          <nav className="mt-8 flex flex-col gap-1">
            {items.map((it) => {
              const Icon = it.icon;
              return (
                <NavLink key={it.to} to={it.to} end={it.end} data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-primary text-primary-foreground" : "text-foreground/80 hover:bg-muted"}`}>
                  <Icon className="h-4 w-4" /> {it.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="mt-auto space-y-2">
            <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-foreground/80 hover:bg-muted">
              <ExternalLink className="h-4 w-4" /> View website
            </a>
            <button onClick={() => { signOut(); navigate("/admin/login"); }} data-testid="admin-logout-btn"
              className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-destructive hover:bg-destructive/10">
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </aside>

        {/* main */}
        <div className="flex-1 min-w-0">
          <header className="sticky top-0 z-20 flex items-center justify-between border-b border-border bg-card/80 px-5 py-3 backdrop-blur lg:px-8">
            <div className="flex items-center gap-2 lg:hidden">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white"><Ship className="h-4 w-4" /></span>
              <span className="font-heading font-bold">Admin</span>
            </div>
            <div className="ml-auto flex items-center gap-3 text-sm">
              <span className="text-muted-foreground">{user?.email}</span>
              <button onClick={() => { signOut(); navigate("/admin/login"); }} className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-xs font-medium hover:bg-muted lg:hidden">
                <LogOut className="h-3.5 w-3.5" /> Out
              </button>
            </div>
          </header>
          {/* mobile nav */}
          <div className="flex gap-2 border-b border-border bg-card px-5 py-2 lg:hidden">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end}
                className={({ isActive }) => `rounded-full px-3 py-1.5 text-sm font-medium ${isActive ? "bg-primary text-primary-foreground" : "text-foreground/70"}`}>
                {it.label}
              </NavLink>
            ))}
          </div>
          <main className="p-5 lg:p-8"><Outlet /></main>
        </div>
      </div>
    </div>
  );
}
